import { AppleCredential } from '../../connector/auth';

// Hand-off state between the Signup/Login pages and the AcceptTerms page. Deliberately in-memory
// only: the account is created only AFTER the user accepts the ToS there, so nothing (especially
// not the password or Google credential) is persisted anywhere before that. A page reload loses
// the state and AcceptTerms sends the user back to /signup.
export interface PendingSignup {
  // Password signup: email + password are set; completing requires ToS + Turnstile.
  email?: string;
  password?: string;
  tag?: string; // test-data tag (pipe-trick without secret); such signups still pass the turnstile
  // Google signup: the Google id_token; completing requires only the ToS (no Turnstile) and
  // retries googleLogin with tosAccepted=true.
  googleCredential?: string;
  // Apple signup: like Google, retries appleLogin with tosAccepted=true.
  appleCredential?: AppleCredential;
  invitationCode?: string;
}

let pending: PendingSignup | undefined;

export function setPendingSignup(p: PendingSignup | undefined): void {
  pending = p;
}

export function getPendingSignup(): PendingSignup | undefined {
  return pending;
}
